import React from 'react';
import {
    Create,

    Toolbar,
    SaveButton,
} from 'react-admin';
import Export from './Export'
import Import from './Import'
import Scan from './Scan'
import ErrorBoundary from '../ErrorBoundary';

const styles = {
    flex: { display: 'flex' },
    flexColumn: { display: 'flex', flexDirection: 'column' },
    leftCol: { flex: 1, marginRight: '1em' },
    rightCol: { flex: 1, marginLeft: '1em' },
    singleCol: { marginTop: '2em', marginBottom: '2em' },
};

const UploadCreateToolbar = props => (
    <Toolbar {...props} >
        <SaveButton
            label="Upload"
            submitOnEnter={true}
            redirect="/donors"
        />
    </Toolbar>
);

const DownloadCreate = ({...props }) => (
    <ErrorBoundary>  
    <Create  title='File downloads'   {...props}>
      <div style={styles.flexColumn}>
        <div style={styles.flex} >
            <Export />
            <Import />
            <Scan />
        </div>
      </div>
     
    </Create>
    </ErrorBoundary>  
)

export default DownloadCreate;
